// extracted by mini-css-extract-plugin
export var defaultWrapper = "_kb-3";
export var downloadButton = "_kb-4";
export var fileContainer = "_kb-9 _kb-7";
export var fileContainerBase = "_kb-7";
export var fileContainerBaseSm = "_kb-a _kb-7";
export var fileContainerFixedHeight = "_kb-8 _kb-7";
export var fileContainerFixedHeightSm = "_kb-c _kb-a _kb-7";
export var fileContainerSm = "_kb-b _kb-a _kb-7";
export var fileInfo = "_kb-5";
export var fileInfoWidthRestricted = "_kb-6";
export var fileType = "_kb-1";
export var fileTypeName = "_kb-2";
export var fileTypeSm = "_kb-d _kb-1";
export var image = "_kb-0";
export var link = "_kb-f";
export var overflowEllipsis = "_kb-e";